import { createContext, PropsWithChildren } from 'react';

import useSoundInitializer, { PlaySoundOptions } from './useSoundInitializer';

type SoundContextType = {
  playSound: (src: string, options?: PlaySoundOptions) => void;
  initializeAudio: (outputId: string | null) => void;
  isPlaying: boolean;
};

export const SoundContext = createContext<SoundContextType | null>(null);

const SoundProvider = ({ children }: PropsWithChildren) => {
  const { playSound, initializeAudio, isPlaying } = useSoundInitializer();

  return <SoundContext.Provider value={{ playSound, initializeAudio, isPlaying }}>{children}</SoundContext.Provider>;
};

export default SoundProvider;
